/* eslint-disable max-len */
import React from 'react';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Prompt } from '../../../ui';
import { useResolve } from '../../Container';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { ElementSelector2 } from '../../canvas/ui/ElementSelector2';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { BuzzerPreview } from '../buzzer/BuzzerPreview';
import { CounterPreview } from '../counter/CounterPreview';
import { JukeboxPreview } from '../jukebox/JukeboxPreview';
import { SpinnerPreview } from '../spinner/SpinnerPreview';
import { StopwatchPreview } from '../stopwatch/StopwatchPreview';
import { VoterPreview } from '../voter/VoterPreview';

export const GadgetWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useObserverReturningStore(useResolve(ToolManager));

    const onSelect = (toolId: string) =>
        (selectMode: 'click' | 'drag') => {
            widget.update({ open: !widget.autoClose });

            const mode = selectMode === 'click' ? 'plop' : 'drop';

            // tools.setSettings(toolId, item.props);
            dispatch(toolEquip, [toolId, `${mode}:`]);
        };

    return <Prompt ignoreMouse ignoreEnter onAction={() => widget.update({ open: false })}>
        <Flexer relative >
            {/* <ElementSelector name="gadgets" model={model} onSelectItem={onSelect} /> */}
            <ElementSelector2 name="gadgets" contentWidth="22" height="32">
                <ElementSelector2.Content>
                    <ElementSelector2.Group anchor="gadgets" label="Gadgets">
                        <Flexer flex="row" gap="1">
                            <Flexer flex="column" gap="1" width="50%">
                                <ElementSelector2.Item label="Jukebox" onAction={onSelect('jukeboxTool')}>
                                    <JukeboxPreview />
                                </ElementSelector2.Item>
                                <ElementSelector2.Item label="Voter" onAction={onSelect('voterTool')}>
                                    <VoterPreview />
                                </ElementSelector2.Item>
                                <ElementSelector2.Item label="Spinner" onAction={onSelect('spinnerTool')}>
                                    <SpinnerPreview />
                                </ElementSelector2.Item>
                            </Flexer>
                            <Flexer flex="column" gap="1" width="50%">
                                <ElementSelector2.Item label="Counter" onAction={onSelect('counterTool')}>
                                    <CounterPreview />
                                </ElementSelector2.Item>
                                <ElementSelector2.Item label="Timer" onAction={onSelect('stopwatchTool')}>
                                    <StopwatchPreview />
                                </ElementSelector2.Item>
                                <ElementSelector2.Item label="Buzzer" onAction={onSelect('buzzerTool')}>
                                    <BuzzerPreview width="9rem" />
                                </ElementSelector2.Item>
                            </Flexer>
                        </Flexer>
                    </ElementSelector2.Group>
                </ElementSelector2.Content>
            </ElementSelector2>
            {/* <Position inset=".6" at="topRight">
                <KeepPopoutWidgetOpenButton widget={widget} />
            </Position> */}
            {/* <HaugButtonHangingMount>
                <HaugButton label="Learn about Stickies & Cards" haug={PaperHaug} />
            </HaugButtonHangingMount> */}
        </Flexer>
    </Prompt>;
});


